export enum AlertTypes {
    Success,
    Info,
    Error,
    Warn
}

export interface AlertInfo {
    type: AlertTypes;
    text: string;
    icon?: string;
    duration: number;
}
